module.exports = __webpack_public_path__ + "img/console02.dc3395f2.jpg";